export const SET_HRES81X_LABELS = 'SET_HRES81X_LABELS'
export const GET_HRES81X_LABELS = 'GET_HRES81X_LABELS'
export const SET_HRES81X_INDEX = 'SET_HRES81X_INDEX'
export const GET_HRES81X_INDEX = 'GET_HRES81X_INDEX'
export const SET_HRES81X_FLG_PROCESS = 'SET_HRES81X_FLG_PROCESS'
export const GET_HRES81X_FLG_PROCESS = 'GET_HRES81X_FLG_PROCESS'
export const SET_HRES81X_FLG_LOGIN_SUCCESS = 'SET_HRES81X_FLG_LOGIN_SUCCESS'
export const GET_HRES81X_FLG_LOGIN_SUCCESS = 'GET_HRES81X_FLG_LOGIN_SUCCESS'
export const SET_HRES81X_NUMPERIOD = 'SET_HRES81X_NUMPERIOD'
export const GET_HRES81X_NUMPERIOD = 'GET_HRES81X_NUMPERIOD'
export const SET_HRES81X_LAST_NUMPERIOD = 'SET_HRES81X_LAST_NUMPERIOD'
export const GET_HRES81X_LAST_NUMPERIOD = 'GET_HRES81X_LAST_NUMPERIOD'
export const RECEIVED_HRES81X_INDEX = 'RECEIVED_HRES81X_INDEX'
export const RECEIVED_HRES81X_NUMPERIOD = 'RECEIVED_HRES81X_NUMPERIOD'
export const RECEIVED_COLUMNS_LABELS = 'RECEIVED_COLUMNS_LABELS'
export const POST_HRES81X_PRINT = 'POST_HRES81X_PRINT'
export const POST_HRES81X_LOGIN = 'POST_HRES81X_LOGIN'



// WEBPACK FOOTER //
// ./src/store/modules/hres81x/mutation-types.js